import CreateComplexModal from 'features/CreateComplexModal';
import CreateLotModal from 'features/CreateLotModal';
import CreateOrganizationModal from 'features/CreateOrganizationModal';
import EditLotModal from 'features/EditLotModal';
import EditComplexModal from 'features/EditComplexModal';
import EditOrganizationModal from 'features/EditOrganizationModal';

const Windows = (): JSX.Element => (
  <>
    <CreateOrganizationModal />
    <CreateComplexModal />
    <CreateLotModal />
    <EditOrganizationModal />
    <EditComplexModal />
    <EditLotModal />
  </>
);

export default Windows;
